<!--
 * @Author: cn1994
 * @Date: 2023-08-23 10:11:23
 * @LastEditors: cn1994
 * @LastEditTime: 2023-10-20 17:55:46
 * @Description: 预览图左侧导航组件
-->
<template>
  <div class="ls-left-opration-component">
    <img v-if="userInfo.role == 'groupAdmin'" class="moer" src="https://cdnws.51tyty.com/lstyty/file/2023/11/28/9c509e66a3e72d4919d7d4c9a435e148.png">
    <div class="right">
      <div class="functional-zone">
        <section
          v-for="item in leftConfig"
          :key="item.id"
        >
          <div
            class="item"
            v-if="item.role.includes(role)"
          >
            <img class="icon" :src="item.icon">
            <span class="title">{{ item.title }}</span>
          </div>
        </section>
      </div>
      <div class="user-cell">
        <img class="avatar" :src="userInfo.avatar">
        <span class="name">{{ userInfo.name }}</span>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object,
    },
    leftConfig: {
      type: Array,
      default: []
    },
    role: {
      type: String,
    }
  },
}
</script>

<style lang="less" scoped>
.ls-left-opration-component {
  display: flex;
  flex-direction: row;
  align-items: center;
  .moer {
    width: 15px;
    height: 78px;
  }
  .right {
    flex: 1;
    height: 270px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 13px;
    .functional-zone {
      flex: 1;
      position: relative;
      margin-bottom: 14px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      overflow-y: auto;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 13px;
        .icon {
          width: 38px;
          height: 38px;
        }
        .title {
          font-size: 12px;
          color: #fff;
          font-weight: 500;
          text-shadow: 0px 1px 4px rgba(0,0,0,0.4);
          line-height: 17px;
          margin-top: 3px;
        }
      }
    
    }
    .user-cell {
      display: flex;
      flex-direction: column;
      align-items: center;
      .avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        overflow: hidden;
      }
      .name {
        font-size: 9px;
        color: #333;
        line-height: 13px;
        display: inline-block;
        padding: 2px 4px;
        background: linear-gradient(136deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.8) 100%);;
        border-radius: 20px;
        backdrop-filter: blur(7.92px);
        width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 4px;
        text-align: center;
      }
    }
  }
  
}
</style>